import * as React from 'react';

import styles from './case-report-info.scss';

interface CaseReportFailedExecuteProps {
  translation: any;
  errorsExecuteFailed: string[];
}

export const CaseReportFailedExecute = React.memo(({
  translation,
  errorsExecuteFailed
}: CaseReportFailedExecuteProps) => {
  return (
    <div className={`${styles.uiToggleInfo} ${styles.warningInfo}`}>
      <div className={`${styles.title} ${styles.warningMsg}`}>{translation.toggle_info_title}</div>
      <div className={`${styles.subTitle} ${styles.warningMsg}`}>{errorsExecuteFailed}</div>
      <div className={`${styles.warningDescription}`}>{translation.execute_failed_info_description}</div>
    </div>
  );
});
